import { Box, styled } from '@mui/material';

export const InputHint = styled('span')`
  position: absolute;
  top: 85px;
  left: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.p050};

  @media (max-width: 1023px) {
    top: 59px;
    left: 0;
    font-size: 12px;
  }
`;

export const FieldErrorBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.danger.p010};

  svg {
    font-size: 20px;
    color: ${({ theme }) => theme.palette.danger.main};
    flex-shrink: 0;
  }
`;

export const FieldErrorText = styled('span')`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.overlay};
`;
